import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'shifts',
  children: {
    templates: {
      size: 'full',
      path: 'rotating-shifts',
      children: {
        templatesShiftTemplateId: {
          size: 'full',
          path: ':shiftTemplateId',
          children: {
            edit: {
              path: 'edit',
              children: {
                weeksWeekIdEdit: {
                  path: 'weeks/:weekId/edit',
                },
              },
            },
          },
        },
      },
    },
    savedShifts: {
      path: 'saved-shifts',
      children: {
        newSavedShift: {
          path: 'new',
        },
        editSavedShift: {
          path: ':id/edit',
        },
      },
    },
    customView: {
      size: 'full',
      path: ':viewType/:year/:month/:day',
    },
    customViewGroup: {
      size: 'full',
      path: ':viewType/:groupType/:year/:month/:day',
      children: {
        exportAnnualBalance: {
          path: 'export-annual-balance',
        },
        exportSchedule: {
          path: 'export-schedule',
        },
        printSchedule: {
          path: 'print-schedule',
        },
        insightsRequest: {
          path: 'insights-request',
        },
        insightsSidepanel: {
          path: 'insights-sidepanel',
        },
      },
    },
  },
} as const satisfies Location
